export default __webpack_public_path__ + "static/silverPreviewImg-a127fe9470ccf80e8028bbf013477447.png";